export const ADMIN_ENDPOINT = {
  GetDefParam: 'admin/DefParams/{paramCd}',
  GetOneCloudConfigurations: 'admin/Configurations',
  GetLookups: 'admin/Lookups/{tableId}',
  UpdateOneCloudConfiguration: 'admin/Configuration/{configurationName}'
};
